import axios, { AxiosResponse, AxiosError } from 'axios';
import React, {useEffect} from 'react';
import { Navbar, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import dunlopLogo from '../../assets/img/dunlop_logo.png';
import personCircle from '../../assets/img/person-circle.svg';
import '../../assets/css/header/header.css';
import { useAuth } from '../../context/AuthContext';
import { sysStatusToString } from '../../utils/define';

const Header = () => {
  // TODO:ログアウトAPI実行、成功時ログイン画面に遷移。
  const { getAuthData } = useAuth();
  const navigate = useNavigate();
  const { clearAuthData } = useAuth();

  const callLogOutApi = () => {
    clearAuthData();  // 認証情報をクッキーから削除
    navigate('/login'); // ログイン画面へリダイレクト
  };

  return (
    <Navbar expand="true" className="m-0 p-0 shadow-sm">
      <Navbar.Brand as="span" className='m-0 p-0'>
        <img
          src={dunlopLogo}
          width="auto"
          height="auto"
          alt="DUNLOP"
        />
      </Navbar.Brand>
      <h1 className='d-none d-md-inline m-0 fs-5'>月次タイヤレポート</h1>
      <div className='d-flex align-items-center me-3'>
        <div className='d-flex align-items-center'>
          <img className='me-3' src={personCircle} width="30" height="30" alt="DUNLOP" />
          <div className='d-none d-sm-inline me-3'>
            <div>{getAuthData()?.admin_name}</div>
            <div>{sysStatusToString(getAuthData()?.sys_status)}</div>
          </div>
        </div>
        <NavDropdown
          className='w-auto'
          title={''}
          id="basic-nav-dropdown"
          align="end"
        >
          <NavDropdown.Item 
            className='text-danger text-center' 
            onClick={callLogOutApi}
          >
            ログアウト
          </NavDropdown.Item>
        </NavDropdown>    
      </div>      
    </Navbar>
  );
};

export default Header;
